<template lang="pug">
#legenda
    .container
        h6.title-text {{ $t('mensagens.comuns.legendas') }}
        .item-container
            .item-legenda(v-for='(value, index) in values', :key='index')
                .icon-legenda
                    .square(:style='{ backgroundColor: value.color }')
                .titulo(v-if="value.name.includes('mensagens')") {{ $t(value.name) }}
                .titulo(v-else) {{ $t(`mensagens.cultura.${value.name}`) }}
</template>

<script>
export default {
    name: 'Legenda',

    props: {
        values: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss">
#legenda {
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 10px;
    right: 10px;
    z-index: 1020;
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    .title-text {
        font-size: 13px;
        font-weight: 500;
    }

    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
    }

    h6 {
        margin: 0;
        font-weight: 600;
    }

    .item-legenda {
        display: flex;
        align-items: center;

        .icon-legenda {
            margin-right: 5px;

            .square {
                width: 15px;
                height: 15px;
            }
        }

        .titulo {
            font-size: 14px;
        }
    }
    
    .item-container {
        display: flex;
        gap: 5px
    }
}
</style>
